export const storeLegacyBooking = (value: boolean) => {
  localStorage.setItem('LEGACY_BOOKING', value ? 'true' : 'false');
};

export const legacyBookingEnabled = () => localStorage.getItem('LEGACY_BOOKING') === 'true';

export const removeLegacyBooking = () => {
  localStorage.removeItem('LEGACY_BOOKING');
};
